export default __webpack_public_path__ + "static/Banner-Juvederm-2-6d24646dc3740fac36faeac0b0a83a64.jpg";